import React, { useState, useEffect } from "react";
import Button from "./Button";



const Questions = ({ labels, langId, activeQuestion, baseColors, setActiveQuestion, colors, categories, questions, setQuestions }) => {


    const [start, setStart] = useState(false);



    useEffect(() => {
        setStart(false);


    }, [activeQuestion, setStart]); // Empty dependency array ensures this effect runs only once

    useEffect(() => {

        if (!start) {



            setTimeout(() => {

                setStart(true);
            }, 100);
        }


    }, [start]); // Empty dependency array ensures this effect runs only once



    function changeScore(e, question) {
        let score = parseInt(e.target.value);

        if (isNaN(score)) {
            score = 0;
        }
        questions[question.id].score = score;


        Object.values(categories).map((category) => {
            let total = 0;

            category.sub.forEach((s) => {

                if (questions[s].score) {
                    total += questions[s].score;
                }

            })


            category.score = Math.round(total / category.sub.length);
            return true;
        })


        setQuestions({ ...questions });

    }




    return <div className={"flex flex-col text-center   "}>






        {Object.values(questions).map((question, index) => (
            (index === activeQuestion &&

                <div  >

                    <div className="flex justify-center items-center mb-5">
                        <div key={"circle"} style={{ backgroundColor: baseColors[categories[question.parent].index] }} className="rounded-full bg-primary w-16 h-16 flex items-center justify-center">{activeQuestion + 1} / {Object.values(questions).length} </div>
                    </div>
                    <div className={"slide-block   " + (start ? "opacity-100 ease-in-out duration-300 transition" : "")}>
                        <div className="mb-5">

                            <h2 className="font-bold text-xl leading-none mb-2" >{categories[question.parent].lang?.[langId]?.title}</h2>
                            <h3 className="font-bold text-lg mb-2">{question.lang?.[langId]?.title}</h3>
                        </div>

                        <div dangerouslySetInnerHTML={{ __html: question.lang?.[langId]?.summary }}></div>

                    </div>
                    <div className="flex justify-center mt-5">
                        <div className=" p-5 relative  rounded-lg border-2 " style={{ "borderColor": colors[index] }}>
                            <div className="z-10 relative">
                                <input step="1" value={(question.score > 0 ? question.score : 0)} defaultValue={(question.score > 0 ? question.score : 0)} onChange={(e) => changeScore(e, question)} className="border px-2 py-1" type="range" min="0" max="10" />

                                <div>{labels?.["your-number"]?.lang?.[langId]?.name}: {question.score} / 10</div>
                            </div>

                            <div className="absolute left-0 top-0 bottom-0 right-0" style={{ "opacity": question.score / 10, "backgroundColor": colors[index] }} ></div>
                        </div>
                    </div>


                    <div className="flex space-x-5 justify-center mt-5">
                        <Button onClick={() => setActiveQuestion(activeQuestion - 1)} disabled={!activeQuestion} backgroundColor={baseColors[categories[question.parent].index]}>{labels?.["previous"]?.lang?.[langId]?.name}</Button>
                        <Button onClick={() => setActiveQuestion(activeQuestion + 1)} disabled={activeQuestion === Object.values(questions).length} backgroundColor={baseColors[categories[question.parent].index]}>{labels?.["next"]?.lang?.[langId]?.name}</Button>

                    </div>

                </div>
            )
        ))}



    </div >
}

export default Questions;
